import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  useMediaQuery,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
} from "@material-ui/core";

import VerificationCode from "./VerificationCode";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;
export default function ConsultationPage() {
  return (
    <>
      <Box>
        <ConsultationContent />
      </Box>
    </>
  );
}

//ANHCOR ConsultationContent
function ConsultationContent() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    backImg: {
      height: "calc( 100vh - 64px  )",
      width: "100%",
      objectFit: "fill",
    },
    formBox: {
      height: "100%",
      minHeight: "100vh",
      // position: "absolute",
      // top: "0",
      // bottom: "0",
      // left: "50%",
      // transform: "translateX(-50%)",
      width: "100%",
      backgroundImage: "url('/assets/images/Search/detailSearch.png')",
      backgroundSize: "cover",
    },
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .MuiInputBase-input ": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box position="relative">
        {/* <Box width="100%">
          <img
            src="/assets/images/Search/detailSearch.png"
            className={classes.backImg}
          />
        </Box> */}
        <Box className={classes.formBox}>
          {/* <SearchForm2/> */}
          <SearchForm />
        </Box>
      </Box>
    </div>
  );
}

function SearchForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      minHeight: "100vh",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
    helperText: {
      position: "absolute",
      bottom: 0,
      transform: "translateY(100%)",
    },
  }));

  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const Alert = useAlert();
  const { handleSubmit, control, getValues, setValue, reset } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      remark: "",
      vcode: "",
    },
  });
  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          Alert.notice("送出成功");
          if (history.location.state?.url)
            return history.replace(history.location.state?.url);
          else return window.location.reload();
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  function _submit(data) {
    const customerInput = {
      customerType: "SERVICE_AREA",
      source: "NETWORK",
      assignStatus: "WAITING_TO_CONTACT",
      remark: `我要諮詢=>留言：${data.remark}`,
      customerInfo: [
        {
          fullName: data.fullName,
          mobile1: data.mobile,
          line: data.lineId,
        },
      ],
      frontSite: true,
    };

    saveCustomer({ variables: { customerInput } });
  }
  useEffect(() => {
    if (!!history.location.state?.object) {
      setValue("remark", history.location.state.object);
    }
  }, [history.location.state]);
  return (
    <Container maxWidth="lg" style={{ height: "100%" }}>
      <LoadingModal loading={saveCustomerLoading} />
      <Box py={4} className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box color="#fff">
              <Typography variant={isTable ? "h4" : "h2"} align="center">
                我要諮詢
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={isTable ? "2" : "4"}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      姓名
                    </Typography>
                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>

            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <Controller
                name="remark"
                control={control}
                rules={{
                  required: "請輸入留言",
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                  >
                    <TextareaAutosize
                      {...field}
                      name="message"
                      placeholder="留言"
                      style={{
                        height: "120px",
                        width: "100%",
                        resize: "none",
                        fontSize: "1em",
                        padding: "10px",
                      }}
                    />
                    <FormHelperText className={classes.helperText}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item md={5} xs={3}>
              <Controller
                name="vcode"
                control={control}
                rules={{
                  validate: (v) => {
                    if (v !== localStorage.getItem("@fullhouseVcode"))
                      return "驗證碼錯誤";
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      驗證碼
                    </Typography>
                    <Grid container item spacing={1} direction="row">
                      <Grid item>
                        <TextField
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid item>
                        <VerificationCode />
                      </Grid>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </Grid>
          {/* form area end */}
        </Grid>
        {/* button */}

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              width: isTable ? "100%" : "30%",
              marginTop: "50px",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
